import {
  MissionBackgroundRotation2Image,
  MissionBackgroundParticle2Image,
  MissionRewardIcon,
  MissionTrophyBigIcon,
} from '@local/assets/images'

import Image, { PupKeywordEmoji } from '@web/components/Image'
import { useRegistToSequentialList } from '@web/libs/sequential'

import styles from '../MissionRewardPopup.module.scss'

interface Props {
  title: string
  amount: number
  animationOrder: number
}

const PhotoReviewRewardPopup = ({ title, amount, animationOrder }: Props) => {
  useRegistToSequentialList({
    order: animationOrder * 100,
    onExecute: () => {},
    type: 'afterPrev',
    delaySeconds: 0,
    durationSeconds: 1,
    id: `reward-popup-${animationOrder}`,
  })

  return (
    <>
      <div className={styles.animation_wrapper}>
        <Image className={styles.img_bg} src={MissionBackgroundRotation2Image} width={680} height={680} alt="" />
      </div>
      <div className={styles.animation_wrapper}>
        <Image className={styles.img_particle} src={MissionBackgroundParticle2Image} width={375} height={340} alt="" />
      </div>
      <div className={styles.content}>
        <div className={styles.mission}>미션 결과</div>
        <div className={styles.tit_area}>{title}!</div>
        <div className={styles.reward_area}>
          <Image className={styles.img_particle} src={MissionTrophyBigIcon} width={157} height={157} alt="" />
        </div>
        <div className={styles.txt_area}>
          <Image className={styles.icon} src={MissionRewardIcon} width={29} height={29} alt="" />
          <em>포인트 {amount.toLocaleString()}원</em> 지급!
        </div>
        <div className={styles.description_area}>
          축하합니다
          <Image className={styles.icon} src={PupKeywordEmoji.PARTY_POPPER} width={18} height={18} alt="" />
          이달의 리뷰어에 선정되었어요!
          <br />
          앞으로도 멋진 사진과 리뷰 기대할게요.
        </div>
      </div>
    </>
  )
}

export default PhotoReviewRewardPopup
